import styled from 'styled-components';

export const Content = styled.div`
  margin: 0 0 1rem;
  padding: 0 10px;
  position: relative;
  color: #e6eaec;
  &.is-app {
    padding: 0;
  }
`;

export const Title = styled.div`
  margin: 0 0 8px;
  font-size: 13px;
  color: #aab2b8;
`;

export const Block = styled.div`
  display: flex;
  align-items: center;
`;
